
import { config } from "./config";
import axios from "axios";

export  function getDeviceType() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipad|ipod|android|windows phone/g.test(userAgent);
    const isTablet =
      /(ipad|tablet|playbook|silk)|(android(?!.*mobile))/g.test(userAgent);

    return 'Mobile';
    if (isMobile) return 'Mobile';
    else if (isTablet) return 'Tablet';
    else return 'Desktop';
}
export function isMobile(){
  return !(getDeviceType() == "Desktop")
}
export function isEmail(email){
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
export function editObject(obj, params, values){
    var newObj = {...obj};
    for(var i=0;i<params.length;i++){
        newObj[params[i]] = values[i];
    }
    return newObj;
}
export function setAgentCode(code){
  localStorage.setItem("AgentCode", code);
}
export function getAgentCode(){
  var agentCode = localStorage.getItem("AgentCode");
  if(IsIntNumber(agentCode)){
    var ac = parseInt(agentCode);
    if(ac >= 100){
      return ac;
    }
  }
  return 0;
}
export function setCurrentUser(user){
  var ExpireTime = new Date().getTime() / 1000;
  ExpireTime += (config.UserTokenExpirePerMinute * 60 * 1000);

  user.ExpireTime = ExpireTime;    
  console.log("user to set is>", user)                
  localStorage.setItem("HanaAdminAccount", JSON.stringify(user));  
}
export function generateRandomUString(howmanycharacters){
    const charBank = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";

    let random= '';
    for (let i = 0; i < howmanycharacters ; i++) {
        random+= charBank[parseInt(Math.random() * charBank.length)];
    }

    return random;
}

export function getCurrentUser(){
    var str = localStorage.getItem("HanaAdminAccount");
    if(str &&(str != "")){
      var user = JSON.parse(str);
      return user;
    }
    return null;
}
export function clearCurrentUser(){
    localStorage.removeItem("HanaAdminAccount");
}
  export function getUserRoleTitle(role){
    switch(role){
      case UserRoles.Admin: return "ادمین";
      case UserRoles.Assistant: return "دستیار ادمین";
      case UserRoles.Client: return "مشتری";
      case UserRoles.Agent: return "نماینده فروش";
    }
    return "-";
  }
  export function getCurrentUserRole(){
    var user = getCurrentUser();
    if(user == null) return 0;
    return user.role;
    
  }
  export function isLogedInLocal(){
    var user = getCurrentUser();
    if(user == null) return false;
    if(user.UserId == "") return false;
    var ExpireTime = new Date().getTime() / 1000;
    if(user.Role <=0) return false;
    
    if(user.ExpireTime>= ExpireTime) return true;
    
    return false;
    
  }
  export function getLoginDto(){
    var userId = "";
    var token = "";
    var role = 0;
    var user = getCurrentUser();
    if(user != null){
      if(user.id != ""){
        if(user.role.id >0){
          userId = user.id;
          token = user.session.token;
          role = user.role.id;
        }
      }
    }
    return {userId: userId, token: token, role:role};
  }
  export function isLogedInServer(loggedInHandler, notLoggedInHandler){
    var user = getCurrentUser();
    console.log("user in check sever is>", user);
    if(user == null) {notLoggedInHandler(); return false;}
    if(user.UserId == "") {notLoggedInHandler(); return false;}
    var ExpireTime = new Date().getTime() / 1000;
    if(user.Role <=0) {notLoggedInHandler(); return false;}
    
    if(user.ExpireTime< ExpireTime) {notLoggedInHandler(); return false;}
    
    var params = {login:getLoginDto()};
    var url = config.Server + `/user/logged-in/check`;
    console.log("params in ckeck user logged in is>", params);
    console.log("url in ckeck user logged in is>", url);
    axios
    .post(url, params )
    .then(response => {
        response = response.data;
        console.log("response in ckeck user logged in is> ", response)
        if(response.state === "ok"){
            response = response.data;
            setCurrentUser(response);
            loggedInHandler();
            return true;
        }
        else{
            notLoggedInHandler();
            return false;
        }
    })
    .catch(error => {
    console.log("error is>", error)
            notLoggedInHandler();
            return false;
    });
    
  }

  export function SeperatePrice(x){
    if(x === 0) return "0";
    if(x === "0") return "0";
    if(!x) return "";
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  export function SeperateDate(x){
    var tmp = x.toString();
    if(tmp.length === 8){
      return tmp.substring(0, 4) + "/" + tmp.substring(4, 6) + "/" + tmp.substring(6, 8);
    }else{
      return tmp;
    }
  }
  export function SeperateTime(x){
    var tmp = x.toString();
    while(tmp.length <6){ tmp = "0" +  tmp;
    }
    return tmp.substring(0, 2) + ":" + tmp.substring(2, 4) + ":" + tmp.substring(4, 6);
  }
  export function IsMobileValid(mobile){
    if(mobile === null){
      return {valid:false, msg:"موبایل مشخص نشده است"};
    }
    if(mobile.trim() === ""){
      return {valid:false, msg:"موبایل مشخص نشده است"};
    }
    if(mobile.trim().length != 11){
      return {valid:false, msg:"موبایل باید 11 رقمی باشد"};
    }
    if(mobile.indexOf("09") != 0){
      return {valid:false, msg:"موبایل باید با 09 شروع شود"};
    }
    return {valid:true, msg:"معتبر است"};
  }
export function IsValidNationalCode(input){
    if(input.length == 12){ 
      if(IsNumber(input)) return true;
      return false;
    }
    if (!/^\d{10}$/.test(input)) return false; // فقط ۱۰ رقم
    
    // همه ارقام یکی نباشن
    if (/^(\d)\1{9}$/.test(input)) return false;
    
    const check = parseInt(input[9]);
    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(input[i]) * (10 - i);
    }
    const remainder = sum % 11;
    
    if((remainder < 2 && check === remainder) || 
           (remainder >= 2 && check === 11 - remainder)){
            return true;
           }
           else{
            return false;
           }
  };
export function RemoveIntZeros(n) {
    while (String(n).substr(0, 1) == "0") {
        n = String(n).substr(1, n.length - 1);
    }
    if (n == "") return 0;
    else return parseInt(n);
}
export function IsIntNumber(n) {
    if (n == null) return false;
    if (isNaN(n)) return false;
    n = String(n);
   // if(n === 0) return true;
   // if(n === "0") return true;
    if (n == "") return false;
    if (n % 1 != 0) return false;
    while (String(n).substr(0, 1) == "0") {
        n = String(n).substr(1, n.length - 1);
    }
    if (n == "") return true;
    if (n != parseInt(n)) return false;
    return true;
}
export function IsNumber(n) {
    if (n == null) return false;
    if (n == "") return false;
    if (isNaN(n)) return false;
    while (String(n).substr(0, 1) == "0") {
        n = String(n).substr(1, n.length - 1);
    }
    if (n == "") return true;
    if (n != parseFloat(n)) return false;
    return true;
}
export function ReplaceStr(text, search, replace){
    while(text.indexOf(search) >=0){
      text = text.replace(search, replace);
    }
    return text;
  }
export function getWeekDayName(ind){
  switch(ind){
    case 0: return "شنبه";
    case 1: return "یکشنبه";
    case 2: return "دوشنبه";
    case 3: return "سه شنبه";
    case 4: return "چهارشنبه";
    case 5: return "پنچشنبه";
    case 6: return "جمعه";
  }
  return "";
}
export function getMonthName(ind){
  ind = parseInt(ind);
  switch(ind){
    case 1: return "فروردین";
    case 2: return "اردیبهشت";
    case 3: return "خرداد";
    case 4: return "تیر";
    case 5: return "مرداد";
    case 6: return "شهریور";
    case 7: return "مهر";
    case 8: return "آبان";
    case 9: return "آذر";
    case 10: return "دی";
    case 11: return "بهمن";
    case 12: return "اسفند";
  }
  return "";
}
export function getEducationName(){
  return toPersianDigits("1405 - 1404");
}
export function toPersianDigits(num){
  return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
};  
export function toEnglishDigits(str) {
  str = String(str);
  return str.replace(/[\u06F0-\u06F9\u0660-\u0669]/g, function (d) {
    // یونیکد فارسی: \u06F0 تا \u06F9
    // یونیکد عربی:  \u0660 تا \u0669
    var charCode = d.charCodeAt(0);
    if (charCode >= 0x06F0 && charCode <= 0x06F9) {
      return charCode - 0x06F0; // فارسی
    } else if (charCode >= 0x0660 && charCode <= 0x0669) {
      return charCode - 0x0660; // عربی
    }
    return d;
  });
}; 
export function scrollToElement(myref, pos) {
    //pos: center or start
    myref.current?.scrollIntoView({
        behavior: "smooth",
        block: pos, // یا "center" or "start"
    });
}
//--------------------------------------------------------------------------------------------------------------------------
export function getBuy(){
  var str = localStorage.getItem("HanaAdminBuy");
  if(str){
    if(str != ""){
      var buy = JSON.parse(str);
      if(buy.enName){
        if(buy.enName != ""){
          return buy;
          // var buy = {
          //     productId:"",
          //     enName:selectedProduct.product.enName,
          //     productType:productType,
          //     modules:modules,
                // parameters :{
                //     maxClientNo:maxClientNo,
                //     maxVisitorNo:maxVisitorNo,
                //     maxStudentNo:maxStudentNo,
                //     maxSchoolNo:maxSchoolNo,
                //     maxMemberNo:maxMemberNo,
                //     maxBillNo:maxBillNo
                // },
                //price:price,
                //discountToken:discountToken,
                //discountMobile:discountMobile,
          // };
        }
      }
    }
  }
  return null;
}
export function saveBuy(buy){
  deleteBuy();
  localStorage.setItem("HanaAdminBuy", JSON.stringify(buy));  
}
export function deleteBuy(){
  localStorage.removeItem("HanaAdminBuy"); 
  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getBuyService(){
  var str = localStorage.getItem("HanaAdminBuyService");
  if(str){
    if(str != ""){
      var buy = JSON.parse(str);
      return buy;
    }
  }
  return null;
}
export function saveBuyService(buy){
  deleteBuyService();
  localStorage.setItem("HanaAdminBuyService", JSON.stringify(buy));  
}
export function deleteBuyService(){
  localStorage.removeItem("HanaAdminBuyService"); 
  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getBuyCompany(){
  var str = localStorage.getItem("HanaAdminBuyCompany");
  if(str){
    if(str != ""){
      var buy = JSON.parse(str);
      return buy;
      // var buyCompany = {
      //     isPersonal:isPersonal,
      //     personNationalId:personNationalId,
      //     economicCode:economicCode,
      //     companyNationalId:companyNationalId,
      //     title:title,
      //     city:city
      //}
    }
  }
  return null;
}
export function saveBuyCompany(buyCompany){
  localStorage.setItem("HanaAdminBuyCompany", JSON.stringify(buyCompany));  
}
export function deleteBuyCompany(){
  localStorage.removeItem("HanaAdminBuyCompany");    
}
//--------------------------------------------------------------------------------------------------------------------------
export function getClientContract(){
  var str = localStorage.getItem("HanaAdminClientContract");
  if(str){
    if(str != ""){
      var contract = JSON.parse(str);
      return contract;
    }
  }
  return null;
}
export function saveClientContract(contract){
  localStorage.setItem("HanaAdminClientContract", JSON.stringify(contract));  
}
export function deleteClientContract(){
  localStorage.removeItem("HanaAdminClientContract");  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getOtherSystemDetail(){
  var str = localStorage.getItem("HanaAdminOtherSystemDetail");
  if(str){
    if(str != ""){
      var detail = JSON.parse(str);
      return detail;
    }
  }
  return {otherSystemIdentity:"", mobile:"", firstname:"", lastname:"", enName:"", companyTitle:""};
}
export function saveOtherSystemDetail(otherSystemIdentity, mobile, firstnamee, lastname, enName, companyTitle){
  localStorage.setItem("HanaAdminOtherSystemDetail", JSON.stringify({otherSystemIdentity:otherSystemIdentity, mobile:mobile, firstname:firstnamee, lastname:lastname, enName:enName, companyTitle:companyTitle}));  
}
export function deleteOtherSystemDetail(){
  localStorage.removeItem("HanaAdminOtherSystemDetail");  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getAfterLoginUrl(){
  var str = localStorage.getItem("HanaAdminAfterLoginUrl");
  if(str == null) str = "";
  return str;
}
export function saveAfterLoginUrl(afterLoginUrl){
  localStorage.setItem("HanaAdminAfterLoginUrl", afterLoginUrl);  
}
export function deleteAfterLoginUrl(){
  localStorage.removeItem("HanaAdminAfterLoginUrl");  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getBeforeIpgUrl(){
  var str = localStorage.getItem("HanaAdminBeforeIpgUrl");
  if(str == null) str = "";
  return str;
}
export function saveBeforeIpgUrl(afterLoginUrl){
  localStorage.setItem("HanaAdminBeforeIpgUrl", afterLoginUrl);  
}
export function deleteBeforeIpgUrl(){
  localStorage.removeItem("HanaAdminBeforeIpgUrl");  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getIpgTransactionType(){
  var str = localStorage.getItem("HanaAdminIpgTransactionType");
  if(str == null) str = "";
  return str;
}
export function saveIpgTransactionType(ipgTransactionType){
  localStorage.setItem("HanaAdminIpgTransactionType", ipgTransactionType);  
}
export function deleteIpgTransactionType(){
  localStorage.removeItem("HanaAdminIpgTransactionType");  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getIpgTransactionAmount(){
  var str = localStorage.getItem("HanaAdminIpgTransactionAmount");
  if(str == null) str = "";
  return str;
}
export function saveIpgTransactionAmount(ipgTransactionAmount){
  localStorage.setItem("HanaAdminIpgTransactionAmount", ipgTransactionAmount);  
}
export function deleteIpgTransactionAmount(){
  localStorage.removeItem("HanaAdminIpgTransactionAmount");  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getUserAndPass(){
  var str1 = localStorage.getItem("HanaAdminUsername");
  if(str1 == null) str1 = "";
  var str2 = localStorage.getItem("HanaAdminPassword");
  if(str2 == null) str2 = "";
  var res = [str1, str2];
  return res;
}
export function saveUserAndPass(username, password){
  localStorage.setItem("HanaAdminUsername", username);  
  localStorage.setItem("HanaAdminPassword", password);  
}
export function deleteUserAndPass(){
  localStorage.removeItem("HanaAdminUsername");  
  localStorage.removeItem("HanaAdminPassword");  
}
//--------------------------------------------------------------------------------------------------------------------------
export function getSoftwareTargetContractNo(){
  var res = localStorage.getItem("HanaAdminSoftwareContractNo");
  return res;
}
export function saveSoftwareTargetContractNo(contractNo){
  localStorage.setItem("HanaAdminSoftwareContractNo", contractNo);  
}
export function deleteSoftwareTargetContractNo(){
  localStorage.removeItem("HanaAdminSoftwareContractNo");  
}
//--------------------------------------------------------------------------------------------------------------------------
export const ProductTypes = {
    WinHanaAccounting:1,
    SchoolManagment:2,
    AmoozeshgahManagment:3,
    SandooghManagment:4,
    TaxSerivce:5,
    GavahiHoghogh:6,
};
export function getProductTypeTitle(pType){
  if(pType == ProductTypes.WinHanaAccounting) return "بسته های نرم افزاری حسابداری";
  if(pType == ProductTypes.SchoolManagment) return "حسابداری و مدیریت مالی مدارس";
  if(pType == ProductTypes.AmoozeshgahManagment) return "حسابداری و مدیریت مالی آموزشگاه";
  if(pType == ProductTypes.SandooghManagment) return "صندوقهای وام قرض الحسنه و اعتبار";
  if(pType == ProductTypes.TaxSerivce) return "ارسال صورتحساب به سامانه مودیان مالیاتی";
  if(pType == ProductTypes.GavahiHoghogh) return "سامانه صدور گواهی کسر حقوق کارکنان";
  return "unknown";
}
export function getAllProductTypes(){
  var res = [
    {id:ProductTypes.WinHanaAccounting},
    {id:ProductTypes.SchoolManagment},
    {id:ProductTypes.AmoozeshgahManagment},
    {id:ProductTypes.SandooghManagment},
    {id:ProductTypes.TaxSerivce},
    {id:ProductTypes.GavahiHoghogh}
  ];
  for(var i=0;i<res.length;i++){
    res[i]["title"] = getProductTypeTitle(res[i].id);
  }
  return res;
}
//--------------------------------------------------------------------------------------------------------------------------
export const IpgTypes = {
    Zarinpal:1,
};
//--------------------------------------------------------------------------------------------------------------------------
export const WallerTransactionTypes = {
  IncreaseWalletAmount : 1,
  BuyProduct : 2,
  RecontinueContract : 3,
  PromoteContractParameter : 4,
  PromoteContractModule:5,
  BuySmsCharge : 6,
  PaymentTax : 7,
  BuyService : 8,
}
export const ContractTransactionTypes = {
  Buy : 1,
  Recontinue : 2,
  PromoteModule : 3,
  PromoteParameter : 4,
}
//--------------------------------------------------------------------------------------------------------------------------
export const ContractParameterTypes = {
  MaxStudentNo : 1,
  MaxMemberNo : 2,
  MaxClientNo : 3,
  MaxSchoolNo : 4,
  Url : 5,
  MaxBillNo : 6,
  MaxVisitorNo : 7  ,
}
//--------------------------------------------------------------------------------------------------------------------------
export const IpgTransactionStates = {
    Request : 1,
    WaitToVerify : 2,
    Accepted : 3,
    Failed : 4,

};
export const UserRoles = {
    Any:0,
    Admin:1,
    Assistant:2,
    Agent:3,
    Client:4,
};
export const scoreTypes = {
    ContinualTest:1,
    MonthAverage:2,
};
export const describableScores = {
  veryGood:20,
  good:15,
  acceptable:12,
  rejected:8
}
export const OwnerTypes = {
  System : 1,
  User : 2,
  Banner : 3,
  UserResetPassword : 4,
  RequestMembership : 5,
  RequestAgent : 6,
}
export const ParameterTypes = {
  SessionTimeout : "SessionTimeout",
  RecontinuePercents : "RecontinuePercents",
  InflationRates : "InflationRates",
  DefaultInflationRate : "DefaultInflationRate",
  RecontinueWarning : "RecontinueWarning",
  SmsCodeTimeout : "SmsCodeTimeout",
  StudentNumberPriceRangeForIndependentSchool : "StudentNumberPriceRangeForIndependentSchool",
  MemberNumberPriceRangeForLoanCenter : "MemberNumberPriceRangeForLoanCenter",
  PricePerCleintForWinAccounting : "PricePerCleintForWinAccounting",
  PricePerSubSchoolForSchoolManagment : "PricePerSubSchoolForSchoolManagment",
  BillNumberPriceRangeForTaxService : "BillNumberPriceRangeForTaxService",
  PricePerVisitorForWinAccounting : "PricePerVisitorForWinAccounting",
  IpgMinAmount : "IpgMinAmount",
  TaxPercent : "TaxPercent",
  BillDescription1 : "BillDescription1",
  BillDescription2 : "BillDescription2",
  BillDescription3 : "BillDescription3",
  BillDescription4 : "BillDescription4",
  BillDescription5 : "BillDescription5",
}
export const SoftwareUrlTypes = {
  Ticket:"Ticket",
  Recontinue:"Recontinue",
  Upgrade:"Upgrade",
}
export const colors = [
  "#3366CC", // آبی پررنگ
  "#DC3912", // قرمز ملایم
  "#fc9f14ff", // نارنجی
  "#109618", // سبز متوسط
  "#990099", // بنفش تیره
  "#0099C6", // آبی فیروزه‌ای
  "#DD4477", // صورتی تمشکی
  "#66AA00", // سبز روشن
  "#B82E2E", // قرمز زرشکی
  "#316395", // آبی نفتی
  "#994499", // بنفش
  "#22AA99", // سبز آبی ملایم
  "#AAAA11", // زرد زیتونی
  "#6633CC", // بنفش آبی
  "#ce6903ff", // نارنجی تیره
  "#8B0707", // قهوه‌ای مایل به قرمز
  "#329262", // سبز زمردی
  "#5574A6", // آبی فولادی
  "#3B3EAC", // آبی مایل به بنفش
  "#A680B8"  // بنفش روشن
];
export const lightColors = [
  "#FFD966", // زرد روشن
  "#FFB6B9", // صورتی ملایم
  "#A0E7E5", // فیروزه‌ای
  "#B4F8C8", // سبز نعناعی
  "#FBE7C6", // کرم هلویی
  "#C8E3D4", // سبز پاستلی
  "#F6D6AD", // بژ روشن
  "#E3C9FF", // بنفش پاستلی
  "#FDC5F5", // صورتی روشن
  "#C0FDFB", // آبی آبی روشن
  "#FFECB3", // کرم روشن
  "#C2F970", // سبز لیمویی
  "#FAD4D8", // صورتی کمرنگ
  "#E5EDB7", // زیتونی روشن
  "#F8C8DC", // رز پاستلی
  "#C9E4DE", // سبز دودی
  "#FDE2E4", // کرم گل‌بهی
  "#FFF1B6", // زرد روشن پاستلی
  "#CCE2CB", // سبز کمرنگ
  "#EAD5E6"  // بنفش کم‌رنگ
];
export const handlePersianNumberOnInput = (e) => {
    const persianToEnglishMap = {
      '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
      '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
    };
    
    let value = e.target.value;
    let newValue = '';
    
    for (let char of value) {
      newValue += persianToEnglishMap[char] || char;
    }
    
    // فقط اعداد مجاز
    newValue = newValue.replace(/[^0-9]/g, '');
    
    // برای آپدیت state
    if (e.target.value !== newValue) {
      e.target.value = newValue;
      // اگر از state استفاده می‌کنید:
      // setValue(newValue);
    }
};
export const handlePersianNumberOnKeyDown = (e) => {
  const persianNumbers = '۰۱۲۳۴۵۶۷۸۹';
    const englishNumbers = '0123456789';
    const key = e.key;
    
    // اگر عدد فارسی یا انگلیسی است، یا کلیدهای کنترل (مانند Backspace, Delete, Tab, Arrow keys)
    const isControlKey = [
      'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 
      'ArrowUp', 'ArrowDown', 'Home', 'End', 'Enter'
    ].includes(key);
    
    if (!(englishNumbers.includes(key) || persianNumbers.includes(key) || isControlKey)) {
      e.preventDefault();
    }};
export const company = {
  name:"سامانه پرداز وستا",
  nationalId: "31213200006555",
  phone: "08733741916, 08733741914",
  addres:"بهاران 1/17 - محوطه دانشگاه پیام نور - ساختمان پارک علم و فناوری مجتمع نو‌آوران نور",
  boss: "بهمن فتح اللهی",
  url:"Https://Hana.co.ir"
}
